import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";

import "./Faq.scss";
const FeatureFaq = ({ t }) => {
    return (
        <div className="FaqSection">
            <div className="row  m-0">
                <div className="col-md-9">
                    <div>
                        <h4 className="mb-0">Feature FAQ </h4>
                        <p>Ecodrisil® ESG Xpress Copilot Chat-with-Data</p>
                    </div>
                    <div>
                        <h6>Welcome to CWD (Chat-With-Data) BETA! </h6>
                        <p>We're excited to introduce you to <b>CWD</b>, a revolutionary feature that reimagines how you interact with your organization's data on the Ecodrisil ESG Xpress(TM) <br></br> Copilot. By transforming complex data exploration into a simple, conversational experience, CWD empowers you to gain insights effortlessly. As pioneers in this innovative approach, we're thrilled to have you join us in shaping the future of data analysis. </p>
                        <p>
                            We're starting with quantitative data and are excited to announce that integration of qualitative data and additional features are coming soon!
                        </p>
                    </div>
                    <div>

                        <div className="ps-4 mb-4">
                            <h6>
                                1. What is CWD, and how can it benefit me?
                            </h6>
                            <div className="ps-3">
                                <p>
                                    <b>CWD (Chat-With-Data)</b> is a groundbreaking tool that allows you to explore your organization's quantitative data using natural language. Instead of navigating through complex dashboards or reports, you can simply ask questions as if you're chatting with a colleague. CWD provides instant insights, making data analysis more accessible and intuitive—even if you're not a data expert.
                                </p>
                                <h6 className="">Benefits for You: </h6>
                                <ul>
                                    <li><b>Effortless Insights:</b> Obtain quick answers without sifting through complex data. </li>
                                    <li><b>User-Friendly Interface:</b> No technical expertise required.</li>
                                    <li><b>Time Savings:</b> Focus on decision-making rather than data gathering. </li>
                                </ul>
                            </div>
                        </div>

                        <div className="ps-4">
                            <h6>2. How do I start using CWD, and what kind of questions can I ask? </h6>
                            <div className="ps-3">
                                <h6 className="">Getting Started is Easy: </h6>
                                <ul>
                                    <li>
                                        <b>Log In:</b> Access the Ecodrisil ESG Xpress Copilot and navigate to the CWD feature.
                                    </li>
                                    <li>
                                        <b>Explore Sample Questions:</b> You'll find sample questions popping up above the chat window to inspire you.
                                    </li>
                                    <li>
                                        <b>Ask Your Own Questions:</b> Type your questions into the input field.
                                    </li>
                                </ul>
                                <h6 className="">Sample Questions You Can Try: </h6>
                                <ul>
                                    <li>"What is our organization's total carbon emissions in the first quarter?" </li>
                                    <li>"What is the average training hours per employee in the first quarter?" </li>
                                    <li>"What are the total emissions due to mobile combustion in 2024?" </li>
                                </ul>
                                <p>These examples focus on specific metrics within your organization's data, enabling CWD to provide precise and meaningful answers.</p>
                                <h6 className="">Visualizations: </h6>
                                <p>CWD can present data in various formats to enhance your understanding: </p>
                                <ul>
                                    <li><b>Graphs:</b> Generate line, bar, and pie charts to visualize trends and comparisons. </li>
                                    <li><b>Tables:</b> View data in structured tables for detailed analysis. </li>
                                </ul>
                            </div>
                            <div>
                                <h6> 3. What should I avoid asking CWD? </h6>
                                <div className="ps-3">
                                    <p>To ensure you receive accurate and meaningful responses, please avoid: </p>
                                    <ul>
                                        <li>
                                            <b>Hypothetical or Prescriptive Questions:</b> Questions like "How can we reduce emissions?" may prompt CWD to provide creative answers not grounded in your organization's data.
                                        </li>
                                        <li>
                                            <b>External Comparisons:</b> CWD focuses on your organization's data. Questions comparing your data to external entities may not yield accurate results.
                                        </li>
                                        <li>
                                            <b>Outside Data Inquiries:</b> CWD is designed to work with the data available within your organization on the ABC ESG platform.
                                        </li>
                                    </ul>
                                    <p>By asking questions based on your existing data, you'll get the most reliable and actionable insights. </p>
                                </div>
                            </div>
                            <div>
                                <h6> 4. What if I receive an unexpected or inaccurate response? </h6>
                                <div className="ps-3">
                                    <p>
                                        As we're pioneering this new approach in its BETA phase, occasional inaccuracies may occur. If you receive an unexpected response:
                                    </p>
                                    <ul>
                                        <li>
                                            <b>Check the "Chain of Thoughts":</b> This feature shows the AI's reasoning process, helping you understand how it interpreted your question.
                                        </li>
                                        <li>
                                            <b>Refine Your Question:</b> Based on the reasoning, you might rephrase your question for clarity.
                                        </li>
                                        <li>
                                            <b>Provide Feedback:</b> Your feedback is invaluable in helping us improve CWD's accuracy and capabilities.
                                        </li>
                                    </ul>
                                    <p>Your patience and input directly contribute to making CWD a more powerful tool for everyone. </p>
                                </div>
                            </div>
                            <div>
                                <h6> 5. How can I contribute to the evolution of CWD?  </h6>
                                <div className="ps-3">
                                    <p>
                                        Your participation is key to shaping CWD into an indispensable tool:
                                    </p>
                                    <ul>
                                        <li>
                                            <b>Explore and Experiment:</b> The more you use CWD, the smarter it becomes.
                                        </li>
                                        <li>
                                            <b>Share Your Feedback:</b> Let us know what's working well and what could be improved.
                                        </li>
                                        <li>
                                            <b>Stay Tuned for Updates:</b> We're continually adding new features, including qualitative data integration.
                                        </li>
                                    </ul>
                                    <p>By actively engaging with CWD, you're not just benefiting yourself—you're helping to enhance the experience for all users.  </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div>
                        <h6>Thank You for Being a Pioneer with Us! </h6>
                        <p>By embracing CWD, you're at the forefront of a new era in data interaction. Your enthusiasm and insights fuel our commitment to innovation. We appreciate your patience during this BETA phase and are excited to grow together. If you have any questions or need assistance, we're here to help. </p>
                    </div>
                    <div>
                        <h6>Quick Tips for Success </h6>
                        <ul>
                            <li>
                                <b>Start with Sample Questions:</b> They're a great way to discover CWD's capabilities.
                            </li>
                            <li>
                                <b> Be Specific:</b> Clear, detailed questions yield more accurate answers.
                            </li>
                            <li>
                                <b>Use the "Chain of Thoughts":</b> Understand the AI's reasoning to refine your queries.
                            </li>
                            <li>
                                <b>Focus on Available Data:</b> Questions about existing metrics yield the best results.
                            </li>
                            <li>
                                <b>Keep Exploring:</b> Your curiosity not only benefits you but also helps improve CWD for everyone.
                            </li>
                        </ul>
                        <p>We can't wait to see how CWD enhances your data analysis experience. Together, we're redefining what's possible! </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default withTranslation()(FeatureFaq);